Postlogin = (function (my) {
    my.Lesson = (function (self) {
        self.Popup = (function (me) {
            const $modal = $('#beep-9-modal');
            let lastHelpContent = null;
            let lastHelpSegmentId = null;

            me.init = function () {
                //
            };

            me.hideModal = function () {
                // only hide if a modal is actually visible
                if ($('#beep-9-modal').hasClass('activated')) {
                    $('#beep-9-modal').removeClass('activated smaller');
                    $('#light-overlay')
                        .stop()
                        .animate({ opacity: 0 }, 500, () => {
                            $('#light-overlay').remove();
                        });
                    $('#dark-overlay')
                        .stop()
                        .animate({ opacity: 0 }, 500, () => {
                            $('#dark-overlay').remove();
                        });
                    $('#beep-9-modal .content-container').fadeOut(1000);
                    $('#beep-9-modal .activity-mark').fadeIn(1000);
                    $('#beep-9-modal').trigger('beep9:hidden');
                }
            };

            //  * Create and show a modal window
            me.showModal = function (options) {
                const escKey = function (event) {
                    if (event.which === 27) {
                        me.hideModal();
                    }
                };

                $(document).one('keydown', escKey);

                $modal.removeClass('smaller');
                $modal.find('.content-container').removeClass('correct incorrect').fadeOut(200);

                // this makes sure the small version of beep-9 is visible at the bottom
                $modal.addClass('enabled');

                // set a class (ex. 'correct', or 'incorrect' for different screen bg colors)
                // ... this same class will be un-set on hide of the modal.
                if (typeof options.class !== 'undefined') {
                    $modal.find('.content-container').addClass(options.class);
                }

                // if no title set, hide the h2 (more room for content)
                if (typeof options.title === 'undefined') {
                    $modal.find('header h2').hide();
                } else {
                    $modal.find('header h2').show();
                    $modal.find('header h2').html(options.title);
                }

                // set the modal body content
                $modal.find('.beep-9-modal-content > .wrapper > .content').html(options.body);

                if (options.overlay === 'light') {
                    // add the light overlay behind the modal
                    if (!$('#light-overlay').length) {
                        $('body').append('<div id="light-overlay"></div>');
                    }
                    $('#light-overlay')
                        .stop()
                        .animate({ opacity: 1 }, 500, () => {
                            // Animation complete.
                        });
                } else {
                    // add the dark overlay behind the modal
                    if (!$('#dark-overlay').length) {
                        $('body').append('<div id="dark-overlay"></div>');
                    }

                    $('#dark-overlay')
                        .stop()
                        .animate({ opacity: 1 }, 500, () => {
                            // Animation complete.
                        });
                }

                // if specified, set onShow and onHide events
                const onShow = typeof options.onShow === 'function'
                    ? options.onShow
                    : function () {
                        //
                    };
                const onHide = typeof options.onHide === 'function'
                    ? options.onHide
                    : function () {
                        //
                    };

                $modal.unbind('beep9:shown');
                $modal.unbind('beep9:hidden');

                $modal.on('beep9:shown', function (e) {
                    $modal.find('.btn-success:eq(0)').focus();
                    $('#content-container, #header-navigation, #bottom-stuff, #clouds-background-container, #page-container').addClass(
                        'blur',
                    );
                    // $modal.find('.content-container').fadeIn(200);
                    onShow.call(this, e);
                });
                $modal.on('beep9:hidden', function (e) {
                    $modal.find('.btn-success:eq(0)').blur();
                    self.stopAllSounds(false);
                    onHide.call(this, e);
                    // if we had set a class on creation, remove that class on hiding...
                    if (typeof options.class !== 'undefined') {
                        $modal.find('.content-container').removeClass(options.class);
                    }
                    $('#content-container, #header-navigation, #bottom-stuff, #clouds-background-container, #page-container').removeClass(
                        'blur',
                    );
                    // $modal.find('.content-container').fadeOut(200);
                });

                // add any necessary buttons to the footer
                const $footer = $modal.find('footer');
                $footer.html('');
                if (Object.prototype.toString.call(options.actions) === '[object Array]') {
                    for (let i = 0, l = options.actions.length; i < l; i++) {
                        // eslint-disable-next-line no-param-reassign
                        options.actions[i].onClick = typeof options.actions[i].onClick === 'function'
                            ? options.actions[i].onClick
                            : function () {
                                //
                            };
                        $(
                            `<button type="button" class="btn ${options.actions[i].cssClass || ''}">${
                                options.actions[i].label || '{Label Missing!}'
                            }</button>`,
                        )
                            .appendTo($footer)
                            .on('click', options.actions[i].onClick);
                    }
                } else {
                    $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo($footer);
                }

                if (options.smaller) {
                    $modal.addClass('smaller');
                }

                // bring the beep-9 modal to the forefront
                $modal.addClass('activated');

                // hide the activity mark
                $modal.find('.activity-mark').stop().fadeOut(500);

                // bring in the actual content
                $modal.find('.content-container').stop().fadeIn(1000);

                $modal.trigger('beep9:shown');
            };

            me.showCompletionModal = function (segment) {
                if (
                    segment.activity_data.completion_text
                    || segment.activity_data.completion_title
                    || segment.activity_data.completion_audio
                ) {
                    const modalActions = [];

                    // if on the last segment, send to dashboard or cluster overview
                    if (segment.last) {
                        modalActions.push({
                            label: 'Return to Dashboard',
                            cssClass: 'btn-xl btn-success btn-continue btn-return-to-dashboard',
                            onClick(e) {
                                e.stopPropagation();
                                window.location.replace('/student/');
                            },
                        });
                        modalActions.push({
                            label: 'Continue Learning',
                            cssClass: 'btn-xl btn-success btn-continue btn-continue-learning',
                            onClick(e) {
                                e.stopPropagation();
                                window.location.replace(`/career-central/cluster/${self.getVJSSectionID()}/`);
                            },
                        });
                    } else {
                        modalActions.push({
                            label: 'Continue',
                            cssClass: 'btn-xl btn-success btn-continue',
                            onClick(e) {
                                e.stopPropagation();
                                me.hideModal();
                            },
                        });
                    }

                    if (segment.activity_data.completion_audio) {
                        modalActions.push({
                            label: 'Replay <i class="fa fa-volume-up"></i>',
                            cssClass: 'btn-replay-audio btn-default pull-left',
                            onClick(e) {
                                e.stopPropagation();
                                $(this).fadeOut();
                                self.playSound(segment.activity_data.completion_audio, 0, null, () => {
                                    $('#beep-9-modal .btn-replay-audio').fadeIn();
                                });
                            },
                        });
                    }

                    // show the completion-feedback modal window
                    me.showModal({
                        title: segment.activity_data.completion_title,
                        body: segment.activity_data.completion_text,
                        actions: modalActions,
                        onShow() {
                            segment.setCompleted();
                            $('#beep-9-modal .btn-replay-audio').hide();
                            // if there is an audio version of the text, play that file...
                            if (segment.activity_data.completion_audio) {
                                if (
                                    self.soundEnabled()
                                    && !$(`#segment-${self.getCurrentSegmentIndex()}`).hasClass('dont-disable-completion-continue')
                                ) {
                                    $('#beep-9-modal .btn-continue').prop('disabled', true);
                                }
                                self.playSound(segment.activity_data.completion_audio, 500, null, () => {
                                    $('#beep-9-modal .btn-replay-audio').fadeIn();
                                    $('#beep-9-modal .btn-continue').prop('disabled', false);
                                    $(`#segment-${self.getCurrentSegmentIndex()}`).addClass('dont-disable-completion-continue');
                                });
                            }
                        },
                        onHide() {
                            self.pauseCurrentSound();
                            segment.advance();
                        },
                    });
                } else {
                    segment.setCompleted();
                    me.hideModal();
                    segment.advance();
                }
            };

            me.showHelp = function (segment, callback = null, force = false) {
                let helpContent = '';
                if (typeof segment.activity_type !== 'undefined') {
                    helpContent += segment.activity_type;
                }
                if (typeof segment.activity_data !== 'undefined' && segment.activity_data.instructions) {
                    helpContent += segment.activity_data.instructions;
                }

                if (segment.help_enabled && (force || +lastHelpSegmentId === +segment.segment_id || lastHelpContent !== helpContent)) {
                    lastHelpContent = helpContent;
                    lastHelpSegmentId = segment.segment_id;
                    const modalActions = [];

                    $('#content-container, #header-navigation, #bottom-stuff, #clouds-background-container, #page-container').addClass(
                        'blur',
                    );

                    // attempt to pause the segment
                    // if it was playing... then remember to re-start it when modal closes
                    const playWhenClosed = segment.pause();

                    modalActions.push({
                        label: 'Continue',
                        cssClass: 'btn-xl btn-success btn-continue',
                        onClick(e) {
                            e.stopPropagation();
                            me.hideModal();
                        },
                    });

                    // if we have a sound file, add replay button
                    if (segment.activity_data.instructions_audio) {
                        modalActions.push({
                            label: 'Replay <i class="fa fa-volume-up"></i>',
                            cssClass: 'btn-replay-audio btn-default pull-left',
                            onClick(e) {
                                e.stopPropagation();
                                $(this).fadeOut();
                                self.playSound(segment.activity_data.instructions_audio, 0, null, () => {
                                    $('#beep-9-modal .btn-replay-audio').fadeIn();
                                });
                            },
                        });
                    }

                    // show the instructions
                    me.showModal({
                        title: segment.activity_data.instructions_title,
                        body: $(`<div class="content">${segment.activity_data.instructions}</div>`),
                        actions: modalActions,
                        onShow() {
                            $('#beep-9-modal .btn-replay-audio').hide();
                            // if there is an audio version of the text, play that file...
                            if (segment.activity_data.instructions_audio) {
                                if (
                                    self.soundEnabled()
                                    && !$(`#segment-${self.getCurrentSegmentIndex()}`).hasClass('dont-disable-help-continue')
                                ) {
                                    $('#beep-9-modal .btn-continue').prop('disabled', true);
                                }
                                // Safety net: if the instructions audio never
                                // fires its completion callback (failed load,
                                // blocked playback), re-enable Continue so the
                                // user is never trapped on the instructions modal.
                                const continueSafetyTimeout = setTimeout(() => {
                                    $('#beep-9-modal .btn-replay-audio').fadeIn();
                                    $('#beep-9-modal .btn-continue').prop('disabled', false);
                                }, 10000);
                                self.playSound(segment.activity_data.instructions_audio, 500, null, () => {
                                    clearTimeout(continueSafetyTimeout);
                                    $('#beep-9-modal .btn-replay-audio').fadeIn();
                                    $('#beep-9-modal .btn-continue').prop('disabled', false);
                                    $(`#segment-${self.getCurrentSegmentIndex()}`).addClass('dont-disable-help-continue');
                                });
                            }
                        },
                        onHide() {
                            if (typeof callback === 'function') {
                                callback();
                            }

                            if (playWhenClosed) {
                                segment.play();
                            }
                        },
                    });
                } else if (typeof callback === 'function') {
                    callback();
                }
            };

            return me;
        }(self.Popup || {}));

        return self;
    }(my.Lesson || {}));

    return my;
}(Postlogin || {}));
